// Unit conversions for telemetry display.
//
// Joint positions arrive over telemetry in RADIANS (the robotics-standard wire
// format — the device firmware reports radians). The UI displays them in
// degrees, so convert at the render layer only; the data stays in radians.
export const radToDeg = (rad: number): number => (rad * 180) / Math.PI;
